import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from 'src/components/Tile/Tile.scss';
import TileBadge from 'src/components/Tile/TileBadge';
import TileJobName from 'src/components/Tile/TileJobName';
import TileCompanyDetails from 'src/components/Tile/TileCompanyDetails';


const Tile = ({
  children, job, jobLink, logo, company, location, id, isRemoteRecruitment, isSuperOffer, isOneClickApply
}) => {
  const classes = classNames(styles.tile, {
    [styles['tile--super-offer']]: isSuperOffer,
    [styles['tile--remote-recruitment']]: isRemoteRecruitment
  });
  const isHighlighted = isRemoteRecruitment || isSuperOffer;

  return (
    <div className={ classes } data-id={ id } data-test="section-tile">
      <a
        className={ [styles.tile__anchor, styles.anchor].join(' ') }
        data-test="anchor-offerTitle"
        href={ jobLink }
        title={ job }
      >
        {isHighlighted && (
          <TileBadge
            isRemoteRecruitment={ isRemoteRecruitment }
            isSuperOffer={ isSuperOffer }
          />
        )}
        <TileJobName isHighlighted={ isHighlighted } job={ job } />
        <TileCompanyDetails
          company={ company }
          isOneClickApply={ isOneClickApply }
          location={ location }
          logo={ logo }
        />
      </a>
      <div className={ styles.tile__actions }>{ children }</div>
    </div>
  );
};

Tile.propTypes = {
  children: PropTypes.node.isRequired,
  company: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  isOneClickApply: PropTypes.bool.isRequired,
  isRemoteRecruitment: PropTypes.bool.isRequired,
  isSuperOffer: PropTypes.bool.isRequired,
  job: PropTypes.string.isRequired,
  jobLink: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  logo: PropTypes.string
};

Tile.defaultProps = {
  logo: null
};

export default Tile;
